import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SpinnerProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

/**
 * 旋转加载图标组件
 */
export function Spinner({ className, size = 'md' }: SpinnerProps) {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
  }

  return (
    <Loader2
      className={cn('animate-spin text-[#41fcaf]', sizeClasses[size], className)}
      strokeWidth={2.5}
      style={{
        // 确保动画在所有浏览器中平滑运行
        willChange: 'transform',
        animationTimingFunction: 'linear',
      }}
    />
  )
}

interface LoadingScreenProps {
  text?: string
  className?: string
  bgClassName?: string
  size?: 'sm' | 'md' | 'lg'
}

/**
 * 全屏加载组件
 */
export function LoadingScreen({
  text,
  className,
  bgClassName = 'bg-white',
  size = 'lg',
}: LoadingScreenProps) {
  return (
    <div className={cn('flex h-screen items-center justify-center', bgClassName, className)}>
      <div className="flex flex-col items-center gap-3">
        <Spinner size={size} />
        {text && <p className="text-sm text-muted-foreground">{text}</p>}
      </div>
    </div>
  )
}
